@if (!editMode && selectedStarRating) {
  <div>
    @if (selectedStarRating.rank === 0) {
      <span>Not applicable</span>
    }
    @if (selectedStarRating.rank != 0) {
      <div
        class="readonly-skills"
        [matTooltip]="getItemDescription(selectedStarRating)"
      >
        <app-star-rating
          class="evaluation-star-rating"
          [rating]="selectedStarRating.rank"
          [readOnly]="true"
        ></app-star-rating>
      </div>
    }
  </div>
}
@if (editMode && starRatings.length) {
  <div class="editable-skills-container">
    <div class="editable-skills" (mouseleave)="onMouseLeave()">
      <div
        class="level edit-mode na"
        [class.selected-na]="selectedStarRating && selectedStarRating.rank == 0"
        (click)="onStarRatingClickChange({ rating: 0 })"
        (mouseenter)="onStarRatingHoverChange({ rating: 0 })"
      >
        <mat-icon>not_interested</mat-icon>
      </div>
      <app-star-rating
        [rating]="getItemRank(selectedStarRating)"
        [hoverEnabled]="true"
        [staticColor]="getStaticColor(selectedStarRating)"
        (starClickChange)="onStarRatingClickChange($event)"
        (starHoverChange)="onStarRatingHoverChange($event)"
      ></app-star-rating>
    </div>
    @if (hoveredStarRating) {
      <p class="star-rating-desc">
        {{ getItemDescription(hoveredStarRating) }}
      </p>
    }
    @if (!hoveredStarRating && selectedStarRating) {
      <p class="star-rating-desc">
        {{ getItemDescription(selectedStarRating) }}
      </p>
    }
  </div>
}
